<template>
  <div class="metaData">
    <ol>
      <li>App Version: {{ appVersion }}</li>
    </ol>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
const packageJson = require('../../../package.json');

export default {
  name: 'MetaData',
  created() {},
  computed: {
    ...mapGetters({
      device: 'device',
      api: 'apiVersion'
    }),
    firmwareName() {
      return ((this.device || {}).firmware || {}).name || 'N/A';
    },
    modelName() {
      return ((this.device || {}).model || {}).name || 'N/A';
    },
    modelVersion() {
      return ((this.device || {}).model || {}).version || 'N/A';
    },
    apiVersion() {
      return (this.api || {}).version || 'N/A';
    },
    appVersion() {
      return packageJson.version || 'N/A';
    }
  }
};
</script>

<style lang="scss" scoped>
.metaData {
  li {
    @include textSmall;
    line-height: 1.38;
    text-align: center;
    color: $charcoal-grey;
    display: block;
    overflow-wrap: break-word;
  }
}
</style>
